import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { t } from 'ttag';
import useIsMobile from 'hooks/useIsMobile';
import { Skeleton } from 'components';

export default function Description({ description, pathname }) {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(
    /** @type {boolean} isDescriptionExpanded - Whether or not the description is expanded */ false
  );

  const [isDescriptionClamped, setIsDescriptionClamped] = useState(
    /** @type {boolean} isDescriptionClamped - Whether or not the description is clamped */ false
  );

  const isMobile = useIsMobile();

  const descriptionRef = useRef(null);

  useEffect(() => {
    setIsDescriptionExpanded(false);
    if (descriptionRef?.current) {
      setIsDescriptionClamped(
        descriptionRef.current.clientHeight <
          descriptionRef.current.scrollHeight
      );
    }
  }, [description, pathname, isMobile]);

  return (
    <div className="hidden min-h-[100px] space-y-2 sm:block lg:max-w-screen-lg">
      {description || description === '' ? (
        <p
          className={clsx('text-sm leading-normal text-black ', {
            '': !isDescriptionExpanded
          })}
          ref={descriptionRef}
        >
          {description}
        </p>
      ) : (
        <>
          {Array.from(Array(3).keys()).map(index => (
            <Skeleton key={index} width={300 + 25 * index} height={16} />
          ))}
        </>
      )}
      {isDescriptionClamped && (
        <button
          type="button"
          onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
          className="m-0 flex border-0 bg-transparent p-0 text-sm text-black underline focus-visible:outline-none"
        >
          {isDescriptionExpanded ? t`Read Less` : t`Read More`}
        </button>
      )}
    </div>
  );
}

Description.propTypes = {
  /**
   * The Description to Display
   */
  description: PropTypes.string,
  /**
   * The URL Pathname
   */
  pathname: PropTypes.string.isRequired
};

Description.defaultProps = {
  description: undefined
};
